import script from "./PdfDBDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfDBDetail.vue?vue&type=script&setup=true&lang=js"

import "./PdfDBDetail.vue?vue&type=style&index=0&id=d4f6d91a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4f6d91a"]])

export default __exports__